import React from 'react';
import { t } from 'i18next';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

class ModalSupport extends React.Component {
    constructor(props) {
        super(props);

        this._forceUpdate = false;
        this.state = {
            modal: false
        };
    }

    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }
    componentWillUnmount() {
        if (this.props.onRef) {
            this.props.onRef(null);
        }
    }

    render() {
        return (
            <Modal size="md" isOpen={this.state.modal} toggle={this.onToggle}>
                <ModalHeader toggle={this.onToggle}>
                    <h4>
                        <em className="icon-info mr-2"></em>
                        {t('modal.support:title')}
                    </h4>
                </ModalHeader>
                <ModalBody>
                    <strong>{t('modal.support:helpdesk.title')}</strong><br />
                    {t('modal.support:helpdesk.tel')}: <a href="tel:003289449944">+32 (0) 89 44 99 44</a><br />
                    {t('modal.support:helpdesk.mail')}: <a href="mailto:hallo@reservi.be">hallo@reservi.be</a>

                    {/*<br /><br />

                    <strong>{t('modal.support:manual.title')}</strong><br />
                    {t('modal.support:manual.text')}: <a href={t('modal.support:manual.url')} target="_blank" rel="noopener noreferrer">{t('modal.support:manual.download')} <em className="fa fa-external-link-alt"></em></a>

                    <br /><br />

                    <strong>{t('modal.support:teamviewer.title')}</strong><br />
        {t('modal.support:teamviewer.text')}: <a href={t('modal.support:teamviewer.url')} target="_blank" rel="noopener noreferrer">{t('modal.support:teamviewer.download')} <em className="fa fa-external-link-alt"></em></a>
        */}
                </ModalBody>
            </Modal >
        );
    }

    onToggle = () => {
        this.setState({ modal: !this.state.modal });
    }
}

export default ModalSupport;